module.exports = __webpack_public_path__ + "static/media/omocestus_haemorrhoidalis_002_APA.c90fe1d2.png";